// Shared TypeScript types and interfaces
export var UserRole;
(function (UserRole) {
    UserRole["USER"] = "user";
    UserRole["ADMIN"] = "admin";
})(UserRole || (UserRole = {}));
export var LoginResultEnum;
(function (LoginResultEnum) {
    LoginResultEnum["SUCCESS"] = "success";
    LoginResultEnum["INVALID_CREDENTIALS"] = "invalid_credentials";
    LoginResultEnum["USER_NOT_FOUND"] = "user_not_found";
    LoginResultEnum["UNVERIFIED"] = "unverified";
    LoginResultEnum["FORCED_PASSWORD_RESET"] = "forced_password_reset";
})(LoginResultEnum || (LoginResultEnum = {}));
export var RegisterResultEnum;
(function (RegisterResultEnum) {
    RegisterResultEnum["SUCCESS"] = "success";
    RegisterResultEnum["USER_ALREADY_EXISTS"] = "user_already_exists";
    RegisterResultEnum["COGNITO_CREATE_FAILED"] = "cognito_create_failed";
    RegisterResultEnum["UNVERIFIED"] = "unverified";
    RegisterResultEnum["SECONDARY_EMAIL_EXISTS"] = "secondary_email_exists";
})(RegisterResultEnum || (RegisterResultEnum = {}));
export var ResendVerificationEmailResultEnum;
(function (ResendVerificationEmailResultEnum) {
    ResendVerificationEmailResultEnum["SUCCESS"] = "success";
    ResendVerificationEmailResultEnum["USER_NOT_FOUND"] = "user_not_found";
    ResendVerificationEmailResultEnum["SYSTEM_ERROR"] = "system_error";
})(ResendVerificationEmailResultEnum || (ResendVerificationEmailResultEnum = {}));
export var ForgotPasswordResultEnum;
(function (ForgotPasswordResultEnum) {
    ForgotPasswordResultEnum["SUCCESS"] = "success";
    ForgotPasswordResultEnum["USER_NOT_FOUND"] = "user_not_found";
    ForgotPasswordResultEnum["UNVERIFIED"] = "unverified";
})(ForgotPasswordResultEnum || (ForgotPasswordResultEnum = {}));
export var ResetPasswordResultEnum;
(function (ResetPasswordResultEnum) {
    ResetPasswordResultEnum["SUCCESS"] = "success";
    ResetPasswordResultEnum["LINK_EXPIRED"] = "link_expired";
})(ResetPasswordResultEnum || (ResetPasswordResultEnum = {}));
export var ActivateAccountResultEnum;
(function (ActivateAccountResultEnum) {
    ActivateAccountResultEnum["SUCCESS"] = "success";
    ActivateAccountResultEnum["INVALID_TOKEN"] = "invalid_token";
    ActivateAccountResultEnum["TOKEN_EXPIRED"] = "token_expired";
    ActivateAccountResultEnum["USER_NOT_FOUND"] = "user_not_found";
    ActivateAccountResultEnum["SYSTEM_ERROR"] = "system_error";
})(ActivateAccountResultEnum || (ActivateAccountResultEnum = {}));
export var ValidateActivationTokenResultEnum;
(function (ValidateActivationTokenResultEnum) {
    ValidateActivationTokenResultEnum["VALID"] = "valid";
    ValidateActivationTokenResultEnum["TOKEN_EXPIRED"] = "token_expired";
    ValidateActivationTokenResultEnum["INVALID_TOKEN"] = "invalid_token";
})(ValidateActivationTokenResultEnum || (ValidateActivationTokenResultEnum = {}));
export var ChangeEmailResultEnum;
(function (ChangeEmailResultEnum) {
    ChangeEmailResultEnum["SUCCESS"] = "success";
    ChangeEmailResultEnum["EMAIL_EXISTS"] = "email_exists";
    ChangeEmailResultEnum["FORCED_PASSWORD_RESET"] = "forced_password_reset";
    ChangeEmailResultEnum["INVALID_CREDENTIALS"] = "invalid_credentials";
})(ChangeEmailResultEnum || (ChangeEmailResultEnum = {}));
export var ChangeEmailConfirmResultEnum;
(function (ChangeEmailConfirmResultEnum) {
    ChangeEmailConfirmResultEnum["SUCCESS"] = "success";
    ChangeEmailConfirmResultEnum["LINK_EXPIRED"] = "link_expired";
})(ChangeEmailConfirmResultEnum || (ChangeEmailConfirmResultEnum = {}));
export var RefreshResultEnum;
(function (RefreshResultEnum) {
    RefreshResultEnum["SUCCESS"] = "success";
    RefreshResultEnum["INVALID_REFRESH_TOKEN"] = "invalid_refresh_token";
})(RefreshResultEnum || (RefreshResultEnum = {}));
